export const data = [
  {
    id: 1, name: 'name1', type: 'main', color: '#f4f4f4',
  },
  {
    id: 2, name: 'name2', type: 'side', color: '#f8f8f8',
  },
  {
    id: 3, name: 'name3', type: 'section', color: '#f2f2f2',
  },
  {
    id: 4, name: 'name4', type: 'side', color: '#f8f8f8',
  },
  {
    id: 5, name: 'name5', type: 'article', color: '#f4f4f4',
  }
];
